import { render, staticRenderFns } from "./PartyFreeMobile.vue?vue&type=template&id=52d4e5fc"
import script from "./PartyFreeMobile.vue?vue&type=script&lang=js"
export * from "./PartyFreeMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports